// Reglas de correo: la persona decide que se archiva o se destaca solo (p. ej. los avisos de 3CX).
import { useState } from 'react';

import { Icon } from '../lib/icons';
import { guardarReglas, useReglas, type Regla } from '../lib/reglas';
import { Dialog } from './Dialog';
import { toast } from './toasts';

const nueva = (): Regla => ({ id: `r${Date.now().toString(36)}${Math.random().toString(36).slice(2, 5)}`, campo: 'remitente', contiene: '', accion: 'archivar' });

export function ReglasCorreo({ onClose }: { onClose: () => void }) {
  const guardadas = useReglas();
  const [reglas, setReglas] = useState<Regla[]>(guardadas.length ? guardadas : [nueva()]);
  const cambiar = (id: string, c: Partial<Regla>) => setReglas((l) => l.map((r) => (r.id === id ? { ...r, ...c } : r)));
  const guardar = () => {
    guardarReglas(reglas);
    toast('Reglas guardadas.');
    onClose();
  };

  return (
    <Dialog titulo="Reglas de correo" onClose={onClose} width={620}>
      <div className="form">
        <p className="note" style={{ margin: 0 }}>
          Se aplican a los correos que aún no has abierto ni movido. Si sacas un correo del archivo, se queda donde lo pusiste.
        </p>
        {reglas.map((r) => (
          <div key={r.id} className="regla">
            <span>Si</span>
            <select id={`rg-campo-${r.id}`} aria-label="Campo" value={r.campo} onChange={(e) => cambiar(r.id, { campo: e.target.value as Regla['campo'] })}>
              <option value="remitente">el remitente</option>
              <option value="asunto">el asunto</option>
            </select>
            <span>contiene</span>
            <input id={`rg-txt-${r.id}`} aria-label="Texto" value={r.contiene} placeholder={r.campo === 'remitente' ? 'noreply@3cx' : 'Invoice'} onChange={(e) => cambiar(r.id, { contiene: e.target.value })} />
            <span>→</span>
            <select id={`rg-acc-${r.id}`} aria-label="Acción" value={r.accion} onChange={(e) => cambiar(r.id, { accion: e.target.value as Regla['accion'] })}>
              <option value="archivar">archivar</option>
              <option value="destacar">destacar</option>
            </select>
            <button type="button" className="btn sm ghost" aria-label="Quitar regla" onClick={() => setReglas((l) => l.filter((x) => x.id !== r.id))}>
              <Icon name="trash" />
            </button>
          </div>
        ))}
        <button type="button" className="linkish" style={{ alignSelf: 'flex-start' }} onClick={() => setReglas((l) => [...l, nueva()])}>
          + Agregar regla
        </button>
        <div className="actions">
          <button type="button" className="btn ghost" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="btn primary" onClick={guardar}>
            Guardar reglas
          </button>
        </div>
      </div>
    </Dialog>
  );
}
